import { Button, Divider, message,Spin } from "antd";
import Typography from "antd/es/typography/Typography";
import IconSuccess  from "../../PayHostingFee/HostingFeeOrderDetails/success-icon.svg";
// import PhoneIcon from "../../PayHostingFee/HostingFeeOrderDetails/phone.svg";
// import EmailIcon from "../../PayHostingFee/HostingFeeOrderDetails/email.svg";
// import ArrowRight from "../../PayHostingFee/HostingFeeOrderDetails/arrow-right.svg";
import BG from "../../PayHostingFee/HostingFeeOrderDetails/order-bg.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../api/api";
import React,{ useEffect, useState } from "react";
import moment from "moment";
import { IconFails } from "../../../../assets/icons";
import { useTranslation } from "react-i18next";


const NotiDetails = ({ data }) => {

  const [notiDetails, setNotiDetails] = useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [loading, setLoading] = useState(true);

  const {t} = useTranslation();

  const { id } = useParams();

  const navigate = useNavigate();

  const handleBackRoute = () => {
    navigate("/home/notifications");
  }


    // const getNotificationDetails = (id) => {
    //   api
    //     .getNotificationDetails(id)
    //     .then((data) => {
    //       setNotiDetails(data);
    //     })
    //     .catch((error) => {
    //       message.error(error);
    //     });
    // };

    const getNotificationDetails = async (id) => {
    try {
      const res = await api.getNotificationDetails(id);
      setNotiDetails(res);
    } catch (error) {
      message.error(t('fail_fetch_noti_details'));
    } finally {
      setLoading(false); // ✅ stop loading once API finishes
    }
  };


      useEffect(() => {
        Promise.all([
         getNotificationDetails(id)
        ]).finally(() => setDataLoaded(true));
        // eslint-disable-next-line
      }, []);

const handlePhoneClick = () => {
  const phoneNumbers = notiDetails?.data?.contact?.phone_numbers;
  if (phoneNumbers?.length > 0) {
    window.location.href = `tel:${phoneNumbers[0]}`;
  }
};

const handleEmailClick = () => {
  const email = notiDetails?.data?.contact?.email;
  if (email) {
    window.location.href = `mailto:${email}`;
  }
};

if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f7f8fb",
        }}
      >
        <Spin size="large" tip="Loading notification details..." />
      </div>
    );
  }


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 16px",
        backgroundCIconSuccessolor: "#F7F8FB",
        minHeight: "100vh",
      }}
    >
      <div onClick={handleBackRoute} style={{display:"flex",cursor:"pointer",alignItems:"center",gap:"20px",marginBottom:"30px",justifyContent:"start",width:"780px"}}>
        <div style={{border:"1px solid #EAEAEA",borderRadius:"8px",width:"40px",height:"40px",display:"flex", justifyContent:"center", alignItems:"center"}}>
         {/* <img /> */}
         <ArrowLeftOutlined/>
        </div>
        <p style={{fontSize:"24px",color:"#1A1A1A",fontWeight:700,}}>{t('noti_details')}</p>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: 780,
          backgroundColor: "#fff",
          borderRadius: 16,
          overflow: "hidden",
          borderTopLeftRadius:"24px",
          borderTopRightRadius:"24px",
          position:"relative",
        }}
      >
        {/* Top Section - Blue Header */}
        <div
          style={{
            backgroundColor: "#1859FF",
            padding: 26,
            color: "white",
            width:"100%",
            minHeight:"240px",
            display:"flex",
            justifyContent:"center",
            alignItems:"start",
          }}
        >
         
          <div style={{display:"flex",flexDirection:"column",gap:"0px",alignItems:"start",padding:"0px 20px",zIndex:"99",textAlign:"left",width:"100%"}}>
          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
            {(notiDetails?.data?.payment_status === "Failed" || notiDetails?.data?.payment_status === "Overdue" )? 
             <IconFails/>
              :
             <img src={IconSuccess} alt="success-icon" style={{width:"35px",height:"35px"}}/>
            }
            <Typography style={{ fontSize: 24, fontWeight: "bold", color: "#fff" }}>
              {notiDetails?.data?.payment_status === "Failed" ? t('payment_fail') : 
              notiDetails?.data?.payment_status === "Success" ? t('payment_success') :
              notiDetails?.data?.payment_status} 
            </Typography>
          </div>
          <Typography style={{ marginTop: 8, fontSize: 14, color: "#fff",padding:"5px 20px" }}>
            
           {notiDetails?.data ? (
                <div
                    dangerouslySetInnerHTML={{ __html: notiDetails.data.body }}
                />
                ) : (
                ""
                )}
          </Typography>
        </div>
         <img src={BG} alt="order-bg"  style={{
            position:"absolute",
            top:0,
            right:0,
            left:0,
            bottom:0,
            background:"contain",
            // zIndex:"-1",
            width:"95%",
            height:"auto"
          }} />
        </div>
        <div style={{backgroundColor:"#fff",borderTopRightRadius:"24px",borderTopLeftRadius:"24px",marginTop:"-80px",zIndex:"99999 !important"}}>
        {/* White Body Section */}
        <div style={{ padding: 32, display: "flex", flexDirection: "column", gap: 24 }}>
          {/* Order Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Typography style={{ fontWeight: "bold" }}>
                {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" ? t('order_details') :
                notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" ? t('store_details') :
                notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" ? t('order_details') :
                notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" ? t('order_details') :
                notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" ? t('order_details') :
                notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" ? t('store_details') :
                notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" ? t('order_details') :
                ""}
                </Typography>
           {/* SERVER_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" && 
            [
              { label: t('date'), value: moment(notiDetails?.data?.created_at).format("DD MMM YYYY")  },
              { label: t('type'), value: notiDetails?.data?.type === "SERVER_FEE" ? t('server_fee') : "-" },
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
              { label: t('billing_period'),
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_BILLING_ALERT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" && 
            [
              { label: t('type'), value: notiDetails?.data?.type === "MAINTAIN_FEE" ? t('maintain_Fee') : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
              { label: t('store_domain'), value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" && 
            [
             { label: t('date'), value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: t('type'), value: notiDetails?.data?.type === "MAINTAIN_FEE" ? t('maintain_Fee') : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_SUCCESS_PAYMENT */}
            {notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" && 
            [
             { label: "Invoice Number", value: notiDetails?.data?.invoice_no ?? "-"},
             { label: t('date'), value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: t('type'), value: notiDetails?.data?.type === "MAINTAIN_FEE" ? t('maintain_Fee') : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
              { label: t('store_domain'), value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* MAINTAIN_OVERDUE_PAYMENT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" && 
            [
             { label: t('date'), value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: t('type'), value: notiDetails?.data?.type === "MAINTAIN_FEE" ? t('maintain_Fee') : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* HOSTING_BILLING_ALERT */}
           {notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" && 
            [
              { label: t('type'), value: notiDetails?.data?.type === "HOSTING_FEE" ? "Hosting Fee" : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
              { label: t('store_domain'), value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* HOSTING_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" && 
            [
             { label: t('date'), value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: t('type'), value: notiDetails?.data?.type === "HOSTING_FEE" ? "Hosting Fee" : "-" },
              { label: t('template_name'), value: notiDetails?.data?.template?.template_name?.en},
              { label: t('template_id'), value: notiDetails?.data?.template?.template_code},
              { label: t('store_name'), value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
          </div>
          {/* Payment Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
             <Divider />
            <Typography style={{ fontWeight: "bold" }}>Payment Details</Typography>
            {/* SERVER_FAILED_PAYMENT */}
            {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" && 
            [
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.status === "SUCCESS" ? "Successful" : "Failed"},
            { label: t('server_fee'), value: `$${notiDetails?.data?.server_fee}` },
            { label: t('tax'), value: `$${notiDetails?.data?.tax}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
           {/* MAINTAIN_BILLING_ALERT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" && 
            [
            { label: "Payment Period",
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: t('maintain_Fee'), value: `$${notiDetails?.data?.maintain_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
          {/* MAINTAIN_FAILED_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" && 
            [
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: t('maintain_Fee'), value: `$${notiDetails?.data?.maintain_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
          {/* MAINTAIN_SUCCESS_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" && 
            [
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: t('maintain_Fee'), value: `$${notiDetails?.data?.maintain_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
           {/* MAINTAIN_OVERDUE_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" && 
            [
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: t('maintain_Fee'), value: `$${notiDetails?.data?.maintain_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
           {/* HOSTING_BILLING_ALERT */}
          {notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" && 
            [
            { label: "Payment Period",
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: "Hosting Fee", value: `$${notiDetails?.data?.hosting_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
          {/* HOSTING_FAILED_PAYMENT */}
          {notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" && 
            [
            { label: t('pay_with'), value: notiDetails?.data?.payment_method},
            { label: t('payment_status'), value: notiDetails?.data?.payment_status},
            { label: "Hosting Fee", value: `$${notiDetails?.data?.hosting_fee}` },
            { label: t('sub_total'), value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 18,
                fontWeight: "400",
              }}
            >
              <Typography>Total</Typography>
              <Typography style={{fontSize:"24px",fontWeight:"500"}}>${notiDetails?.data?.subtotal}</Typography>
            </div>
          </div>

          <Button
            type="primary"
            style={{ height: 48, backgroundColor: "#1562FF", borderRadius: 6 }}
            block
            onClick={() => navigate("/home/notifications")}>
            Go Back
          </Button>

          {/* <Typography style={{ fontSize: 12, textAlign: "center" }}>
            Read One Site Cart <a href="#">Payment Policy</a> here.
          </Typography> */}
        </div>
        </div>
      </div>
      {/* Contact Us Section */}
    </div>
  );
};

export default NotiDetails;
